import type { ReactNode } from "react";
import { motion } from "framer-motion";

import { fadeUp, viewportOnce } from "@/lib/motion";

interface RevealProps {
  children: ReactNode;
  className?: string;
  /** Optional delay (seconds) for sequenced reveals. */
  delay?: number;
}

/** Wraps children with a subtle fade-up reveal when scrolled into view. */
export function Reveal({ children, className, delay = 0 }: RevealProps) {
  return (
    <motion.div
      variants={fadeUp}
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      transition={{ delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
